import * as angular from 'angular';

import { IdentitySamlForm } from './identity-saml-form.component';
import { IdentitySaml } from './identity-saml.component';
import { IdentitySamlService } from './identity-saml.service';

angular
  .module('identity-saml', [])
  .component('identitySamlForm', IdentitySamlForm)
  .component('identitySaml', IdentitySaml)
  .service('IdentitySamlService', IdentitySamlService);
